// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_MENU_ADD_BAZAAR_PRODUCT = "Inzeruj v bazaru";
export const ADD_MENU_ADD_BLOG_POST = "Napi\u0161 p\u0159\u00edsp\u011bvek";
export const ADD_MENU_ADD_DISCUSSION = "Zalo\u017e diskusi";
export const ADD_MENU_ADD_REVIEW = "P\u0159idej recenzi";
export const ADD_MENU_SUBTITLE_AD = "Nab\u00eddni v\u011bci k prodeji";
export const ADD_MENU_SUBTITLE_DISCUSSION = "Zeptej se na zku\u0161enosti, sd\u00edlej sv\u016fj p\u0159\u00edb\u011bh";
export const ADD_MENU_SUBTITLE_POST = "Pod\u011blte se o moment, tip, inspirujte ostatn\u00ed";
export const ADD_MENU_SUBTITLE_RECIPE = "Inspiruj ostatn\u00ed sv\u00fdmi kulin\u00e1\u0159sk\u00fdmi n\u00e1pady";
export const ADD_MENU_SUBTITLE_REVIEW = "P\u0159idej hodnocen\u00ed, pom\u016f\u017ee\u0161 ostatn\u00edm";
export const ADD_RECIPE = "Pod\u011blte se o sv\u016fj recept";
export const HOMEPAGE_ADD_BUTTON = "P\u0159idej";
